import { PERSISTED_TABS_ID } from '@src/containers/Blotters/TradeAllocations/tokens';
import { shouldRunBlotterTabsMigration } from '../../blotterTabsMigrationVersion';
import { migrateLegacyTabsIntoTradingBlotterPanels } from '../blotterTabsMigrationHelpers';
import type { AppConfigStateWithLegacyLayoutConfigs } from '../legacyLayoutConfigs.types';

/** Moves legacy trade allocations tabs into allocations blotter panel params. */
export function migrateTradeAllocationsTabsToPanelParams(initialConfig: unknown) {
  const config = initialConfig as AppConfigStateWithLegacyLayoutConfigs;
  if (!shouldRunBlotterTabsMigration(config)) {
    return;
  }
  const legacyTabs = config.tabs?.[PERSISTED_TABS_ID];
  if (legacyTabs == null) {
    return;
  }

  migrateLegacyTabsIntoTradingBlotterPanels(config, {
    legacyTabs,
    blotterType: 'allocations',
  });
}
